// GC92-A · destino de retorno tras el login. SÓLO se admite el enlace interno de aprobación
// (`/solicitud/<id>`): nada de URLs absolutas, protocolos, ni rutas con `//` que un tercero pudiera
// colar por el enlace de WhatsApp. La autorización efectiva la sigue decidiendo el backend.
export const RUTA_RETORNO = /^\/solicitud\/[A-Za-z0-9._-]{1,128}$/;

export const destinoSeguro = (valor) =>
  (typeof valor === "string" && RUTA_RETORNO.test(valor)) ? valor : null;
